module.exports = __webpack_public_path__ + "static/media/1.25f443ee.jpg";